// extracted by mini-css-extract-plugin
module.exports = {"main":"_h9","wrapper":"_ia","container":"_ib","content":"_ic","sidebar":"_id"};